import React from 'react';

const CreditImmobilierPage = () => {
    return (
        <div>
            Credit Immobilier
        </div>
    );
};

export default CreditImmobilierPage;